import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import './Navbar.css';

const pages = ['Home', 'About Us', 'Wellness & Fitness', 'Blog', 'Payments'];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const navigate = useNavigate(); // Initialize useNavigate

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleGetScheduledToday = () => {
        navigate('/home'); // Navigate to the home page
        setTimeout(() => {
            const formElement = document.querySelector('.form-container');
            if (formElement) {
                formElement.scrollIntoView({ behavior: 'smooth' }); // Scroll to the form
                const toggleButton = document.querySelector('.header-text');
                if (toggleButton) {
                    toggleButton.click(); // Simulate a click to open the form
                }
            }
        }, 100); // Delay to ensure navigation completes
    };

    return (
        <AppBar position="sticky" sx={{ backgroundColor: 'white' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <a href="/home">
                        <img
                            src='https://i.imgur.com/6o0uQBb.png'
                            alt='Fritz Physical Therapy'
                            style={{ aspectRatio: '1.64', width: '90px', height: 'auto' }}
                        />
                    </a>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href="#app-bar-with-responsive-menu"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: '#883001',
                            textDecoration: 'none',
                        }}
                    >
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="#883001"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <Link
                                        to={
                                            page === 'Home'
                                                ? '/home'
                                                : page === 'About Us'
                                                ? '/about'
                                                : page === 'Wellness & Fitness'
                                                ? '/wellness'
                                                : page === 'Blog'
                                                ? '/blog'
                                                : page === 'Payments'
                                                ? '/payments'
                                                : '#'
                                        }
                                        style={{ textDecoration: 'none', color: '#883001' }}
                                    >
                                        {page}
                                    </Link>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="#app-bar-with-responsive-menu"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: '#883001',
                            textDecoration: 'none',
                        }}
                    >
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Link
                                key={page}
                                to={
                                    page === 'Home'
                                        ? '/home'
                                        : page === 'About Us'
                                        ? '/about'
                                        : page === 'Wellness & Fitness'
                                        ? '/wellness'
                                        : page === 'Blog'
                                        ? '/blog'
                                        : page === 'Payments'
                                        ? '/payments'
                                        : '#'
                                }
                                style={{ textDecoration: 'none', color: '#883001', margin: '0 10px' }}
                            >
                                <Button sx={{ my: 2, color: '#883001', display: 'block' }}>
                                    {page}
                                </Button>
                            </Link>
                        ))}
                    </Box>

                    <Box sx={{ mx: 3, flexGrow: 0, display: 'flex', flexWrap: 'nowrap', gap: { xs: '5px', md: '10px' } }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#883001',
                                color: 'white',
                                fontSize: { xs: '10px', md: '12px' },
                                padding: { xs: '2px 6px', md: '3px 8px' }, // Reduce padding for shorter height
                                lineHeight: 1.2, // Adjust line height for compact appearance
                                minWidth: 'auto',
                            }}
                            onClick={() => window.open('https://g.page/r/Cc5vqfC4bSN0EAg/review', '_blank')}
                        >
                            Submit Review
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#883001',
                                color: 'white',
                                fontSize: { xs: '10px', md: '12px' },
                                padding: { xs: '2px 6px', md: '3px 8px' }, // Reduce padding for shorter height
                                lineHeight: 1.2, // Adjust line height for compact appearance
                                minWidth: 'auto',
                            }}
                            onClick={() => window.location.href = 'tel:+14122781221'}
                        >
                            Call Us 
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#28a745',
                                color: 'white',
                                fontSize: { xs: '10px', md: '12px' },
                                padding: { xs: '2px 6px', md: '3px 8px' }, // Reduce padding for shorter height
                                lineHeight: 1.2, // Adjust line height for compact appearance
                                minWidth: 'auto',
                            }}
                            onClick={handleGetScheduledToday}
                        >
                            Get Scheduled Today
                        </Button>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default ResponsiveAppBar;
